import { COLOR_YELLOW_300 } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSizeWithoutShadow } from './svgMarkerComponents';

const innerDiameter = 24;
export const svgSizeWithoutShadow = getCircleMarkerSizeWithoutShadow(innerDiameter);
const curatedWaypointSvg = createCircleMarker({ imageName: 'curated-waypoint', innerDiameter, innerFill: COLOR_YELLOW_300 });

export default curatedWaypointSvg;
